// extracted by mini-css-extract-plugin
module.exports = {"slsf-switch":"SLSFSwitch_slsf-switch__fB8VE"};